var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseNode',{attrs:{"node":_vm.node,"editor-errors":_vm.editorErrors,"color":"#70ad47"}})}
var staticRenderFns = []

export { render, staticRenderFns }